import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

export const fundAccessGuard: CanActivateFn = (route): boolean => {
  const router = inject(Router);

  const keepOnFundsList = (): false => {
    router.navigate([ROUTE_PATHS.HOME], {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
    return false;
  };

  const id = route.paramMap.get('id');
  if (!id) return keepOnFundsList();

  const fundStatus = router.currentNavigation()?.extras.state?.['fundStatus'];
  if (fundStatus === 'upcoming') return keepOnFundsList();

  return true;
};
